module.exports = __webpack_public_path__ + "static/media/paper21.5456bcb5.jpg";